var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/internet/index.js
// module id = 1733
// module chunks = 0